export default {"src":"/_next/static/media/Logo-backbase.c350fa5c.svg","height":29,"width":166,"blurWidth":0,"blurHeight":0};